'use strict'
//
module.exports = {
  WIN: { os: 'Windows', version: '1.0', type: 'desktop' },
  WIN7: { os: 'Windows 7', version: '7.0', type: 'desktop' },
  WIN8: { os: 'Windows 8', version: '8.0', type: 'desktop' },
  WIN10: { os: 'Windows 10', version: '10.0', type: 'desktop' },
  OSX: { os: 'Macintosh', version: '1.0', type: 'desktop' },
  OSX1: { os: 'Cheetah/Puma', version: '1.0', type: 'desktop' },
  OSX2: { os: 'Jaguar', version: '2.0', type: 'desktop' },
  OSX3: { os: 'Panther', version: '3.0', type: 'desktop' },
  OSX4: { os: 'Tiger', version: '4.0', type: 'desktop' },
  OSX5: { os: 'Leopard', version: '5.0', type: 'desktop' },
  OSX6: { os: 'Snow Leopard', version: '6.0', type: 'desktop' },
  OSX7: { os: 'Lion', version: '7.0', type: 'desktop' },
  OSX8: { os: 'Mountain Lion', version: '8.0', type: 'desktop' },
  OSX9: { os: 'Mavericks', version: '9.0', type: 'desktop' },
  OSX10: { os: 'Yosemite', version: '10.0', type: 'desktop' },
  OSX11: { os: 'El Capitan', version: '11.0', type: 'desktop' },
  OSX12: { os: 'Sierra', version: '12.0', type: 'desktop' },
  IOS: { os: 'ios', version: '1.0', type: 'mobile' },
  IOS5: { os: 'ios-5', version: '5.0', type: 'mobile' },
  IOS6: { os: 'ios-6', version: '6.0', type: 'mobile' },
  IOS7: { os: 'ios-7', version: '7.0', type: 'mobile' },
  IOS8: { os: 'ios-8', version: '8.0', type: 'mobile' },
  IOS9: { os: 'ios-9', version: '9.0', type: 'mobile' },
  IOS10: { os: 'ios-10', version: '10.0', type: 'mobile' },
  ANDROID: { os: 'Android', version: '1.0', type: 'mobile' },
  ANDROID2: { os: 'Gingerbread', version: '2.0', type: 'mobile' },
  ANDROID3: { os: 'Honeycomb', version: '3.0', type: 'mobile' },
  ANDROID4: { os: 'Ice Cream Sandwich', version: '4.0', type: 'mobile' },
  ANDROID43: { os: 'Jelly Bean', version: '4.3', type: 'mobile' },
  ANDROID44: { os: 'KitKat', version: '4.4', type: 'mobile' },
  ANDROID5: { os: 'Lollipop', version: '5.0', type: 'mobile' },
  ANDROID6: { os: 'Marshmallow', version: '6.0', type: 'mobile' },
  ANDROID7: { os: 'Nougat', version: '7.0', type: 'mobile' },
  OTHER: { os: 'unknown mobile os', version: '1.0', type: 'unknown' }
}
